import { useFinanceiroObrasCardsView } from "./use-financeiro-obras-cards-view";
import { FinanceiroObrasCardsView } from "./view-financeiro-obras-cards-view";
import type { FinanceiroObrasCardsViewProps } from "./types-financeiro-obras-cards-view";

/** Liga o ViewModel à View dos Cards. */
export function FinanceiroObrasCards(props: FinanceiroObrasCardsViewProps) {
  const vm = useFinanceiroObrasCardsView(props);
  return <FinanceiroObrasCardsView {...props} {...vm} />;
}

export type * from "./types-financeiro-obras-cards-view";
